import { render, staticRenderFns } from "./MobileDetails.vue?vue&type=template&id=9c85d794&scoped=true"
import script from "./MobileDetails.vue?vue&type=script&lang=js"
export * from "./MobileDetails.vue?vue&type=script&lang=js"
import style0 from "./MobileDetails.vue?vue&type=style&index=0&id=9c85d794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c85d794",
  null
  
)

export default component.exports